import { HTMLAttributes } from "react";
import PublicHead from "./head";
// import Footer from "./footer";

interface IProps extends HTMLAttributes<HTMLDivElement> {}

const Layout = (props: IProps) => {
  const { children } = props;

  return (
    <div>
      <PublicHead />
      {/* <Header isPersonal={isPersonal} /> */}
      <main>{children}</main>
      {/* <Footer friendLinks={friendLinks} /> */}
    </div>
  );
};

export default Layout;
